import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FunctionComponent} from 'react';
import {Route, Routes} from 'react-router-dom';
import {AppRoutes} from './AppRoutes';
import {ProjectsView} from '../views/projects/Projects';
import {ResetPasswordComponent} from '../views/resetpassword/ResetPasswordComponent';
import {isTestEnv} from '../helpers/helpers';
import {DefaultTransition} from '../components/Transition';
import {ChoosePlanView} from '../views/choose-plan/ChoosePlanView';
import {CreateProjectView} from '../views/createproject/CreateProjectView';
import {LogEditView} from '../views/log-edit/LogEditView';
import {LogIntegrationView} from '../views/log-integration/LogIntegrationView';
import {DashboardComponent} from '../views/dashboard/DashboardComponent';
import {SettingsView} from '../views/settings/SettingsView';
import {UserSettingsView} from '../views/usersettings/UserSettingsView';
import {PaymentsView} from '../views/payments/PaymentsView';
import {TermsOfUseView} from '../views/terms-of-use/TermsOfUseView';
import {DevPanel} from '../views/devpanel/DevPanel';
import {RegisterComponent} from '../views/register/RegisterComponent';
import {LoginComponent} from '../views/login/LoginComponent';
import {PrivateRoute} from '../components/PrivateRoute';
import {FlatListStarred} from '../components/flats/FlatListStarred';
import {FlatList} from '../components/flats/FlatList';
import {FlatListAssigned} from '../components/flats/FlatListAssigned';

export function setTitle(v: string) {
    document.title = 'Muscula - ' + v;
    if (isTestEnv()) {
        if (document.location.hostname.includes('test')) {
            document.title = 'Muscula Test - ' + v;
        }

        if (document.location.hostname.includes('localhost')) {
            document.title = 'Muscula Dev - ' + v;
        }
    }
}

export const AppRouting: FunctionComponent<{}> = observer(() => {
    return <Routes>
        <Route
            path={AppRoutes.ResetPassword}
            element={
                <DefaultTransition>
                    <ResetPasswordComponent/>
                </DefaultTransition>}/>

        <Route
            path={AppRoutes.ChoosePlan}
            element={
                <PrivateRoute title="Choose plan">
                    <DefaultTransition>
                        <ChoosePlanView/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route
            path={AppRoutes.CreateProject}
            element={
                <PrivateRoute title="Create project">
                    <CreateProjectView/>
                </PrivateRoute>
            }/>

        <Route

            path={AppRoutes.CreateLog + '/:projectId'}
            element={
                <PrivateRoute title="Create log">
                    <DefaultTransition>
                        <LogEditView/>
                    </DefaultTransition>
                </PrivateRoute>
            }/>

        <Route

            path={AppRoutes.EditLog + '/:logId'}
            element={
                <PrivateRoute title="Edit log">
                    <DefaultTransition>
                        <LogEditView/>
                    </DefaultTransition>
                </PrivateRoute>
            }/>

        <Route

            path={AppRoutes.IntegrationInstructions + '/:logId'}
            element={
                <PrivateRoute title="Integration instructions">
                    <DefaultTransition>
                        <LogIntegrationView/>
                    </DefaultTransition>
                </PrivateRoute>
            }/>

        <Route

            path={AppRoutes.Dashboard + '/:projectId'}
            element={
                <PrivateRoute title="Dashboard">
                    <DefaultTransition>
                        <DashboardComponent/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route
            path={AppRoutes.Settings}
            element={
                <PrivateRoute title="Settings">
                    <DefaultTransition>
                        <SettingsView/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route

            path={AppRoutes.UserAccount}
            element={
                <PrivateRoute title="Account">
                    <DefaultTransition>
                        <UserSettingsView/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route

            path={AppRoutes.Settings + '/:projectId'}
            element={
                <PrivateRoute title="Settings">
                    <DefaultTransition>
                        <SettingsView/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route
            path={AppRoutes.Starred}
            element={
                <PrivateRoute title="Log">
                    <DefaultTransition>
                        <FlatListStarred/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route
            path={AppRoutes.Assigned}
            element={
                <PrivateRoute title="Log">
                    <DefaultTransition>
                        <FlatListAssigned/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />


        <Route
            path={AppRoutes.LogOverview + '/:logId/:flatId'}
            element={
                <PrivateRoute title="Log">
                    <DefaultTransition>
                        <FlatList/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route
            path={AppRoutes.LogOverview + '/:logId/'}
            element={
                <PrivateRoute title="Log">
                    <DefaultTransition>
                        <FlatList/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />


        <Route

            path={AppRoutes.Payments}
            element={
                <PrivateRoute title="Payments">
                    <DefaultTransition>
                        <PaymentsView/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route

            path={AppRoutes.Projects}
            element={
                <PrivateRoute title="Projects">
                    <DefaultTransition>
                        <ProjectsView/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route

            path={AppRoutes.TermsOfUse}
            element={
                <PrivateRoute title="Terms of use">
                    <DefaultTransition>
                        <TermsOfUseView/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route

            path={AppRoutes.DevPanel}
            element={
                <PrivateRoute title="Devpanel">
                    <DefaultTransition>
                        <DevPanel/>
                    </DefaultTransition>
                </PrivateRoute>
            }
        />

        <Route
            path={AppRoutes.Register}
            element={
                <DefaultTransition>
                    <RegisterComponent/>
                </DefaultTransition>
            }
        />

        <Route
            path={AppRoutes.Login}
            element={
                <DefaultTransition>
                    <LoginComponent/>
                </DefaultTransition>
            }
        />

        <Route element={<div>Page not found</div>}/>
    </Routes>;
});
